import service from './service';
/******************************
 * 认证相关
 ******************************/

export const ApiLogin = params => service.post('/api/login', params);
export const ApiLogout = params => service.post('/api/logout', params);
export const ApiRegister = params => service.post('/api/register', params);
export const ApiReset = params => service.post('/api/reset', params);
export const ApiGetEmailCode = params => service.post('/api/verification/email', params);
export const ApiGetSmsCode = params => service.post('/api/verification/sms', params);
/******************************
 * 账户管理
 ******************************/
// 用户信息

export const ApiGetUserInfo = params => service.get('/api/user/info', params); // 更新用户信息

export const ApiUpdateUserInfo = params => service.post('/api/user/update', params);
export const ApiUpdatePassword = params => service.post('/api/user/update/password', params); // 切换团队

export const ApiSwitchTeam = params => service.post('/api/user/team', params);
/******************************
 * 团队管理
 ******************************/
// 获取团队信息

export const ApiGetTeamInfo = params => service.get('/api/team/info', params); // 更新团队信息

export const ApiUpdateTeamInfo = params => service.post('/api/team/update', params); // 解散团队信息

export const ApiDestroyTeam = params => service.post('/api/team/destroy', params);
/******************************
 * 成员管理
 ******************************/
// 成员列表 (含待接受的邀请)

export const ApiGetTeamMember = params => service.post('/api/team/member', params); // 更新成员信息 (改名 / 锁定 / 解锁)

export const ApiUpdateTeamMember = params => service.post('/api/team/member/update', params); // 删除成员

export const ApiDestroyTeamMember = params => service.post('/api/team/member/destroy', params); // 邀请成员 (后端写 team_member_invite 并发送邀请邮件)

export const ApiInviteTeamMember = params => service.post('/api/team/member/invite', params);
/******************************
 * 邀请 (公开接口, 被邀请人未登录)
 ******************************/
// 凭邮件里的 token 查邀请详情 (团队名称/ID + 邮箱)

export const ApiGetInviteInfo = params => service.post('/api/invite/info', params); // 接受邀请: 设置密码 -> 创建用户 -> 加入团队

export const ApiAcceptInvite = params => service.post('/api/invite/accept', params);
/******************************
 * 设备管理
 ******************************/
// 设备列表

export const ApiInstanceList = params => service.post('/api/instance/list', params); // 设备更新

export const ApiUpdateInstance = params => service.post('/api/instance/update', params); // 设备解绑

export const ApiDestroyInstance = params => service.post('/api/instance/destroy', params);
/******************************
 * 团队域名 (team_domains, 按 team_id 隔离; 后端同步 Cloudflare Custom Hostnames)
 ******************************/
// 域名列表 (同时返回 cloudflare_enabled, 未启用时禁用「添加域名」)

export const ApiGetTeamDomainList = params => service.post('/api/team/domain/list', params); // 添加域名 (后端在 Cloudflare 建 Custom Hostname, 返回所有权校验 TXT 记录)

export const ApiCreateTeamDomain = params => service.post('/api/team/domain/create', params); // 刷新验证状态 (重新拉取 Cloudflare 的主机名/证书状态)

export const ApiVerifyTeamDomain = params => service.post('/api/team/domain/verify', params); // 删除域名 (后端级联删除品牌, 并删除 Cloudflare Custom Hostname)

export const ApiDestroyTeamDomain = params => service.post('/api/team/domain/destroy', params);
/******************************
 * 域名品牌 (team_brandings, 与 team_domains 一对一)
 ******************************/
// 品牌列表 (可按 domain_id 过滤)

export const ApiGetTeamBrandingList = params => service.post('/api/team/branding/list', params); // 添加品牌

export const ApiCreateTeamBranding = params => service.post('/api/team/branding/create', params); // 更新品牌

export const ApiUpdateTeamBranding = params => service.post('/api/team/branding/update', params); // 删除品牌

export const ApiDestroyTeamBranding = params => service.post('/api/team/branding/destroy', params); // 公开接口: 按访问域名取白标品牌 (未登录可调用)

export const ApiGetPublicBranding = params => service.post('/api/team/branding/public', params);
/******************************
 * 团队订阅 (team_fin_subscriptions + products, 按 team_id 隔离)
 ******************************/
// 订阅列表 (含产品名称/描述与右侧结算信息)

export const ApiGetTeamSubscriptionList = params => service.post('/api/team/subscription/list', params);
/******************************
 * 团队账单信息 (team_fin_billing_info, 按 team_id 隔离)
 * 付款方式 / 账单邮箱 / 账单地址 三者独立维护
 ******************************/
// 账单信息 (付款方式列表 + 账单邮箱 + 账单地址 + Stripe 配置)

export const ApiGetTeamBillingInfo = params => service.post('/api/team/billing/info', params); // 创建 SetupIntent (前端 Stripe Elements 采集银行卡)

export const ApiCreateTeamBillingSetupIntent = params => service.post('/api/team/billing/setup-intent', params); // 保存 Stripe 采集到的付款方式 (replace_id 非空表示更新/替换旧卡)

export const ApiAttachTeamBillingPayment = params => service.post('/api/team/billing/payment/attach', params); // 更新付款方式 (改持卡人 / 设为主要)

export const ApiUpdateTeamBillingPayment = params => service.post('/api/team/billing/payment/update', params); // 删除付款方式

export const ApiDestroyTeamBillingPayment = params => service.post('/api/team/billing/payment/destroy', params); // 保存账单邮箱

export const ApiSaveTeamBillingEmail = params => service.post('/api/team/billing/email/save', params); // 保存账单地址

export const ApiSaveTeamBillingAddress = params => service.post('/api/team/billing/address/save', params);
/******************************
 * 团队发票 (team_fin_invoices, 按 team_id 隔离)
 ******************************/
// 发票列表 (可按账期 period / 状态 status 过滤)

export const ApiGetTeamInvoiceList = params => service.post('/api/team/invoice/list', params); // 下载发票 PDF (返回二进制流, 用 responseType: 'blob' 接收)

export const ApiDownloadTeamInvoice = params => service.post('/api/team/invoice/download', params, {
  responseType: 'blob'
});
/******************************
 * 项目管理 (团队下的 projects, 切换会写入会话)
 ******************************/
// 团队下的项目列表

export const ApiGetProjectList = params => service.post('/api/project/list', params); // 新增项目

export const ApiCreateProject = params => service.post('/api/project/create', params); // 重命名项目

export const ApiUpdateProject = params => service.post('/api/project/update', params); // 删除项目

export const ApiDestroyProject = params => service.post('/api/project/destroy', params); // 切换当前项目

export const ApiSwitchProject = params => service.post('/api/project/switch', params);
/******************************
 * 接入点管理 (pops, 按 project_id 隔离)
 ******************************/
// 接入点列表

export const ApiGetPopList = params => service.post('/api/pop/list', params); // 新增接入点

export const ApiCreatePop = params => service.post('/api/pop/create', params); // 删除接入点

export const ApiDestroyPop = params => service.post('/api/pop/destroy', params);
/******************************
 * IP 池 / IP 分配
 ******************************/
// IP 池列表(地址段)

export const ApiGetEipList = params => service.post('/api/ip/pool/list', params); // 批量新增 IP 池(支持多个 CIDR / IP 区间, 关联 pop)

export const ApiCreateEip = params => service.post('/api/ip/pool/create', params); // 删除 IP 池

export const ApiDestroyEip = params => service.post('/api/ip/pool/destroy', params); // IP 分配记录列表

export const ApiGetIpAllocationList = params => service.post('/api/ip/list', params); // 申请一个 IP

export const ApiAllocateIp = params => service.post('/api/ip/allocate', params); // 释放一个 IP

export const ApiReleaseIp = params => service.post('/api/ip/release', params);
/******************************
 * 租户管理 (tenants, 按 project_id 隔离)
 ******************************/
// 租户列表

export const ApiGetTenantList = params => service.post('/api/tenant/list', params); // 新增租户

export const ApiCreateTenant = params => service.post('/api/tenant/create', params); // 重命名租户

export const ApiUpdateTenant = params => service.post('/api/tenant/update', params); // 删除租户

export const ApiDestroyTenant = params => service.post('/api/tenant/destroy', params);
/******************************
 * 站点管理 (sites, SD-WAN 站点, 按 project_id + tenant_id 隔离)
 ******************************/
// 站点列表

export const ApiGetSiteList = params => service.post('/api/site/list', params); // 新增站点

export const ApiCreateSite = params => service.post('/api/site/create', params); // 更新站点

export const ApiUpdateSite = params => service.post('/api/site/update', params); // 删除站点

export const ApiDestroySite = params => service.post('/api/site/destroy', params);
/******************************
 * 带宽管理 (tenant_bandwidth, 按 project_id + tenant_id 隔离)
 ******************************/
// 带宽策略列表

export const ApiGetBandwidthList = params => service.post('/api/bandwidth/list', params); // 新增带宽策略

export const ApiCreateBandwidth = params => service.post('/api/bandwidth/create', params); // 更新带宽策略

export const ApiUpdateBandwidth = params => service.post('/api/bandwidth/update', params); // 删除带宽策略

export const ApiDestroyBandwidth = params => service.post('/api/bandwidth/destroy', params);
/******************************
 * GeoIP 大洲 / 国家参考表 (regions, 全局共享)
 * 规则来源/目的 type=continent / country 的取值来源
 * 参考数据由后端 tools/seedregions 从 GeoLite2 产物同步 -> 只读
 ******************************/
// 大洲 / 国家列表(level 可选 continent / country)

export const ApiGetRegionList = params => service.post('/api/region/list', params);
/******************************
 * 中心应用字典 (dpi_application / dpi_app_category, 全局共享)
 * 规则 app 的取值来源: type=application -> dpi_application.id,
 * type=application-category -> dpi_app_category.id
 * 表由 dpi 仓库 (dpi sync / dpi sync-categories) 维护 -> 只读
 ******************************/
// 应用列表(带 category_name, 前端按分类分组)

export const ApiGetApplicationList = params => service.post('/api/application/list', params); // 应用分类列表

export const ApiGetAppCategoryList = params => service.post('/api/app-category/list', params);
/******************************
 * VPN 用户字典 (vpn_users, 按 project_id + tenant_id 隔离)
 * 规则来源/目的 type=vpn-user 的取值来源; 同上, 在规则表单里内联增删
 ******************************/
// VPN 用户列表

export const ApiGetVpnUserList = params => service.post('/api/vpn-user/list', params); // 新增 VPN 用户(同名会返回业务错误)

export const ApiCreateVpnUser = params => service.post('/api/vpn-user/create', params); // 删除 VPN 用户

export const ApiDestroyVpnUser = params => service.post('/api/vpn-user/destroy', params);
/******************************
 * 租户网络规则 (tenant_policy_versions + tenant_network_rules)
 * 按 project_id + tenant_id 隔离; 所有写操作只作用于 draft 版本
 ******************************/
// 版本列表(version_no 降序)

export const ApiGetRuleVersions = params => service.post('/api/rule/versions', params); // 确保存在草稿版本(没有则以最新版本为母版复制一个)

export const ApiEnsureRuleDraft = params => service.post('/api/rule/draft', params); // 版本下的规则列表(version_id 为空 => 当前草稿)

export const ApiGetRuleList = params => service.post('/api/rule/list', params); // 新增规则(rule 为 RuleInput 的 JSON 字符串, enabled 为独立参数)

export const ApiCreateRule = params => service.post('/api/rule/create', params); // 更新规则

export const ApiUpdateRule = params => service.post('/api/rule/update', params); // 删除规则

export const ApiDestroyRule = params => service.post('/api/rule/destroy', params); // 拖拽排序(ids 为完整顺序的 JSON 字符串)

export const ApiReorderRules = params => service.post('/api/rule/reorder', params); // 发布草稿: 置 published + 上一版本置 archived + 下发 etcd

export const ApiPublishRules = params => service.post('/api/rule/publish', params); // 回滚/复制: 指定版本整份复制为新草稿(with_publish=1 则复制后立即发布)

export const ApiRollbackRules = params => service.post('/api/rule/rollback', params);